//#region src/bite_log_transact_campus_card_event.ts
var BiteLogTransactCampusCardEvent = /* @__PURE__ */ function(BiteLogTransactCampusCardEvent) {
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["BalanceInquirySuccess"] = 1] = "BalanceInquirySuccess";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["BalanceInquiryError"] = 2] = "BalanceInquiryError";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["SaleTransaction"] = 3] = "SaleTransaction";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["SaleTransactionError"] = 4] = "SaleTransactionError";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["RefundTransaction"] = 5] = "RefundTransaction";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["RefundTransactionError"] = 6] = "RefundTransactionError";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["AuthorizeLimitSuccess"] = 7] = "AuthorizeLimitSuccess";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["AuthorizeLimitError"] = 8] = "AuthorizeLimitError";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["RetryAttempt"] = 9] = "RetryAttempt";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["ConnectError"] = 10] = "ConnectError";
	BiteLogTransactCampusCardEvent[BiteLogTransactCampusCardEvent["ParseError"] = 11] = "ParseError";
	return BiteLogTransactCampusCardEvent;
}(BiteLogTransactCampusCardEvent || {});
//#endregion
export { BiteLogTransactCampusCardEvent };

//# sourceMappingURL=bite_log_transact_campus_card_event.js.map